/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Container, CssBaseline } from '@mui/material';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/Request';
import Header from '../../../../components/Header';

import { useLoadingContext } from '../../../../providers/use-loading';
import { useSignInContext } from '../../../../providers/use-signin';
import { getStorege } from '../../../../helpers/db_storage';
import { api } from '../../../../services';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';

const Chat: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { data } = useSignInContext();

  const [dataChat, setDataChat] = useState<any>();
  const [dataOrder, setDataOrder] = useState<any>();

  const dataUserStorageOrder = getStorege(
    '@mais/delivery/authorization/orders',
  );

  const getDataChat = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRequest({
        nr_operacao: 76,
        idUsuario: data.user?.idUsuario || dataUserStorageOrder?.idUsuario,
        idPedido: dataOrder?.idPedido,
        nrLatitude: dataOrder?.lat,
        nrLongitude: dataOrder?.lng,
      });

      setDataChat(result.data);
    } catch (error: any) {
      console.log(error);
      toast.error('Ocorreu um erro ao iniciar chat');
    } finally {
      createloading(false);
    }
  };

  useEffect(() => {
    if (dataOrder?.idPedido) {
      getDataChat();
    }
  }, [dataOrder]);

  useEffect(() => {
    const result = getStorege('@chat/order');

    setDataOrder(result);
  }, []);

  return (
    <>
      {dataChat?.token && (
        <Container maxWidth={false} className={classeStyle.container}>
          <Header children="Request" />

          <>
            <CssBaseline />
            <div className={classeStyle.gridChatIframeContainer}>
              <iframe
                className={classeStyle.iframe}
                title="pagamento"
                src={`${process.env.REACT_APP_URL_CHAT}/?token=${dataChat.token}&pwa=true`}
              />
            </div>
          </>
        </Container>
      )}
    </>
  );
};

export default Chat;
